
import React from 'react';
import { Bell } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogTrigger, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { useRealTimeNotifications } from '@/hooks/useRealTimeNotifications';
import NotificationCenter from './NotificationCenter';

const NotificationBell = () => {
  const { unreadCount } = useRealTimeNotifications();

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="relative text-white hover:bg-white/10 border border-white/20 hover:border-white/30 transition-all duration-200"
        >
          <Bell className="w-4 h-4" />
          {unreadCount > 0 && (
            <Badge className="absolute -top-2 -right-2 w-5 h-5 flex items-center justify-center p-0 bg-red-500 text-white text-xs min-w-[20px] border-0">
              {unreadCount > 99 ? '99+' : unreadCount}
            </Badge>
          )}
        </Button>
      </DialogTrigger>
      <DialogContent className="bg-slate-900 border-white/20 text-white max-w-2xl max-h-[80vh] overflow-hidden p-6">
        <DialogTitle className="sr-only">Notifications</DialogTitle>
        <DialogDescription className="sr-only">
          View and manage your notifications
        </DialogDescription>
        <NotificationCenter />
      </DialogContent>
    </Dialog>
  );
};

export default NotificationBell;
